"use client";

import { useEffect, useState } from "react";
import Link from "@/components/atsa/Link";
import type { PracticeMode } from "@/lib/atsa/atsaConfig";

export function TestChrome({
  title,
  status,
  onRestart,
  mode = "training",
  children,
}: {
  title: string;
  status?: React.ReactNode;
  onRestart?: () => void;
  mode?: PracticeMode;
  children: React.ReactNode;
}) {
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    const handler = () => setFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  async function toggleFullscreen() {
    if (document.fullscreenElement) await document.exitFullscreen();
    else await document.documentElement.requestFullscreen();
  }

  if (mode === "simulation") {
    return (
      <div className="fidelity-shell">
        <header className="fidelity-header">
          <div>
            <strong>{title}</strong>
            <span>{status}</span>
          </div>
          <button type="button" onClick={toggleFullscreen}>{fullscreen ? "Exit Fullscreen" : "Fullscreen"}</button>
        </header>
        <main className="fidelity-main">{children}</main>
      </div>
    );
  }

  return (
    <div className="test-page">
      <div className="breadcrumbs"><Link href="/atsa">ATSA Practice</Link><span>/</span><span>{title}</span></div>
      <div className="test-toolbar">
        <div className="toolbar-status">{status}</div>
        <div className="toolbar-actions">
          <button className="text-button" onClick={toggleFullscreen}>{fullscreen ? "Exit Fullscreen" : "Fullscreen"}</button>
          {onRestart && <button className="text-button danger" onClick={onRestart}>Restart</button>}
        </div>
      </div>
      {children}
    </div>
  );
}
